
























































import { Component, Vue } from 'vue-property-decorator'
import CustomDraggable from '@/components/CustomDraggable/index.vue'

@Component({
  name: 'CustomizeLabs',
  components: {
    CustomDraggable
  }
})
export default class extends Vue {
  private group = 'mission'
  private list1 = [

    { name: 'Windows Server', version: '1.0.0' },
    { name: 'Ubuntu', version: '1.0.1' },
    { name: 'Ubuntu', version: '1.0.2' },
    { name: 'Icebox', version: '1.0.0' },
    { name: 'Ident Evil Backdoored VM', version: '1.0.0' },
    { name: 'Exploit Bleed', version: '1.0.0' }
  ]
  private list2 = [
    { name: 'ESA Linux', version: '1.0.0' },
    { name: 'Exploit Equihax', version: '1.0.0' }
  ]
  private labList = [
    { name: 'Service Discovery with Nmap', version: '1.0.0'},
    { name: 'Package Capture: For Evidence and Analysis', version: '1.0.0'},
    { name: 'Traffic Analysis with Wireshark', version: '1.0.0'},
    { name: 'Enumerating Network and Domain Registration', version: '1.0.0'},
    { name: 'Social Engineering Campaign with Gophish', version: '1.0.0'},
    { name: 'Social Engineering Campaign with Gophish', version: '1.0.1'},
    { name: 'Attack Surface - Linux Hardening', version: '1.0.0'},
    { name: 'Attack Surface - Windows Hardening', version: '1.0.0'},
    { name: 'Network Detection with Snort', version: '1.0.0'}
  ]
}
